import { property, state } from 'lit/decorators.js'
import { html } from 'lit'

import { LfuiElement } from '#utils/element'

import LfdsSelectOption, { OPTION_CHANGE_EVENT } from './lfds-select-option.ts'

/**
 * @name LfdsSelectOptgroup
 * @tag lfds-select-optgroup
 * @status beta
 *
 * @description
 * Optgroup element for use inside `lfds-select`.
 */
export default class LfdsSelectOptgroup extends LfuiElement {
	@property() label!: string
	@property({ type: Boolean }) disabled = false

	@state() options: (LfdsSelectOption | HTMLHRElement)[] = []

	updated(changed) {
		this.dispatchEvent(
			new CustomEvent(OPTION_CHANGE_EVENT, { detail: changed })
		)
	}

	#onOptionChange = () => {
		this.requestUpdate()
	}

	#observed: Set<Element> = new Set()

	/**
	 * Listen for option changes on the current set of children only — an option
	 * moved out of this group must stop driving re-renders of it.
	 */
	#observe(elements: Iterable<Element>) {
		for (const previous of this.#observed) {
			previous.removeEventListener(OPTION_CHANGE_EVENT, this.#onOptionChange)
		}

		this.#observed = new Set(elements)

		for (const element of this.#observed) {
			element.addEventListener(OPTION_CHANGE_EVENT, this.#onOptionChange)
		}
	}

	#onslotchange = (event) => {
		this.options = event.target
			.assignedElements()
			.filter(
				(element) =>
					element instanceof LfdsSelectOption ||
					element instanceof HTMLHRElement
			)

		this.#observe(this.options)
	}

	render() {
		return html`<slot @slotchange=${this.#onslotchange}></slot>`
	}
}
